<template funcational>
  <div :class="$style['notification-group']">
    <slot />
  </div>
</template>

<style lang="scss" module>
.notification-group {
  background-color: $grey-light;
  border-radius: $border-radius;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-block-end: 1rem;

  & > * {
    border-radius: 0;
    padding: $spacing $spacing * 2;
  }

  & > :last-of-type {
    border-radius: 0 0 $border-radius $border-radius;
  }

  & > :first-of-type {
    border-radius: $border-radius $border-radius 0 0;
  }
}
</style>
